import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PoButtonModule } from '@po-ui/ng-components';

@Component({
  selector: 'app-acesso-negado',
  standalone: true,
  imports: [PoButtonModule],
  templateUrl: './acesso-negado.html',
  styleUrls: ['./acesso-negado.css'],
})
export class AcessoNegadoComponent {
  constructor(private router: Router) {}

  voltar(): void {
    this.router.navigate(['/notas-list']);
  }
}
